import { useState, useContext, useEffect } from 'react';
import { TreeGridComponent } from '@syncfusion/ej2-react-treegrid';
import {
  ButtonComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import { ThemeContext } from '../../context/theme.context';
import { ProgressBarComponent } from '@syncfusion/ej2-react-progressbar';
import GlobalHierGrid from '../../components/GlobalHierGrid';
var treegridInstance: TreeGridComponent = new TreeGridComponent({});
function AssetHierarchy() {
  const [currentApi, setCurrentApi] = useState('asset-hierarchy');
  const [isPm, setisPm] = useState(false);
  const context = useContext(ThemeContext);
  const filterSettings: any = { type: 'Menu', hierarchyMode: 'Parent' };
  const descTemplate = (args: any) => {
    var theBold = 'normal';
    var color = context.isDarkMode ? 'white' : 'black';
    if (args.isParent) {
      theBold = 'bold';
      color = '#22d3ee';
    }
    return (
      <>
        <span style={{ fontWeight: theBold, color: color }}>
          {args.description}
        </span>
      </>
    );
  };
  const theDesTemplate = descTemplate;
  const handleOnProgressButton = (args: any) => {
    context.setHierarchyDone(true);
  };
  const rebuildAssethierarchy = () => {
    return (
      <div>
        <ButtonComponent
          disabled={context.isHierarchyDone}
          onClick={handleOnProgressButton}
        >
          Rebuilt
        </ButtonComponent>
      </div>
    );
  };

  const switchOnChange = (e: any) => {
    setisPm(e.target.checked)
    if(e.target.checked){
      setCurrentApi("asset-hierarchy/pm")
    }else{
      setCurrentApi("asset-hierarchy")
    }
  };
  const showPMAsseet = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 10,
          marginRight: 10,
          marginLeft: -10,
        }}
      >
        <span style={{ color: '#fff', fontSize: '14px', fontFamily: 'Inter' }}>
          Show PM
        </span>
        <SwitchComponent onChange={switchOnChange} checked={isPm} />
      </div>
    );
  };
  const progressbar = () => {
    return (
      <div>
        {context.isHierarchyDone ? (
          <div
            style={{
              width: '100%',
            }}
          >
            <ProgressBarComponent
              id='linearindeterminate'
              type='Linear'
              value={20}
              width={'250px'}
              isIndeterminate={true}
              labelStyle={{
                text: 'Please wait.',
              }}
              animation={{
                enable: true,
                duration: 2000,
                delay: 0,
              }}
            ></ProgressBarComponent>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  };
  const toolbar: any = [
    'ExpandAll',
    'CollapseAll',
    'Search',
    { template: rebuildAssethierarchy },
    { template: progressbar },
    { template: showPMAsseet },
  ];
  const columns = [
    {
      field: 'id',
      headerText: 'ID',
      width: '90',
      textAlign: 'Left',
      visible: false,
    },
    {
      field: 'description',
      headerText: 'Description',
      width: '400',
      textAlign: 'Left',
      showCheckbox: true,
      template: theDesTemplate,
    },
    {
      field: 'plant_desc',
      headerText: 'Description',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'plant_no',
      headerText: 'Asset No',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
      visible: false,
    },
    {
      field: 'plt_type_codes_1',
      headerText: 'Asset Info 1',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'plt_type_codes_2',
      headerText: 'Asset Info 2',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'plt_type_codes_3',
      headerText: 'Asset Info 3',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'plt_type_codes_4',
      headerText: 'Asset Info 4',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'plt_serial_no',
      headerText: 'Serial Number',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'asset_parent_code',
      headerText: 'Parent Asset',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'parent_project',
      headerText: 'Parent Project',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'asset_code',
      headerText: 'Asset Number',
      textAlign: 'Left',
      width: '90',
    },
    {
      field: 'plt_model',
      headerText: 'Model',
      textAlign: 'Left',
      width: '90',
    },
    {
      width: '100',
      field: 'plt_supplier',
      headerText: 'Supplier',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'plt_manufacturer',
      headerText: 'Manufacturer',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'plant_type',
      headerText: 'Type',
      textAlign: 'Left',
    },

    {
      width: '100',
      field: 'plt_target_mtbf',
      headerText: 'Target MTBF',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'asset_capital_cost',
      headerText: 'Capital Costs',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'mat_total_cost',
      headerText: 'Material Costs',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'total_cost',
      headerText: 'Total Costs',
      textAlign: 'Left',
    },

    {
      width: '100',
      field: 'avg_weekly_usage',
      headerText: 'Weekly Avg Usage',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'last_fail_date',
      headerText: 'Last Fail Date',
      textAlign: 'Left',
      format: 'dd/MM/yyyy',
      type: 'date',
    },

    {
      width: '100',
      field: 'plt_bom_id',
      headerText: 'Asset BOM Number',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'plt_condition',
      headerText: 'Condition',
      textAlign: 'Left',
    },
    {
      width: '100',
      field: 'warranty_date',
      headerText: 'Warranty Date',
      textAlign: 'Left',
    },
  ];
  return (
    <div>
      <GlobalHierGrid
        id='asset-hier-grid'
        get_query={currentApi}
        columns={columns}
        filterSettings={filterSettings}
        toolbarOptions={toolbar}
        hasChildMapping='isParent'
        height='calc(-220px + 100vh)'
        idMapping='id'
        parentIdMapping='pid'
        gridHierRef={(ref) => (treegridInstance = ref)}
        enableTreeSettings={true}
      />
    </div>
  );
}

export default AssetHierarchy;
